angular.module('bribac.components.subjectDetails', [
  'bribac.translations',
  'bribac.components.claimButtons' // Add this dependency
])
  .component('subjectDetails', {
    templateUrl: 'subject-details-component.html',
    controller: 'SubjectDetailsComponentCtrl',
    bindings: {
      subject: '<',
    }
  })
  .controller('SubjectDetailsComponentCtrl', function(
    permissions,
    state,
    ROLES,
    FLAVOUR,
    CLAIMS
  ) {
    var $ctrl = this;
    $ctrl.permissions = permissions;
  });